// PDP 3.4 — PRODUCT MOCK (commerce data). PROTOTYPE ONLY.
// In Shopify every value here comes from the product object, variants, selling plans,
// the cart, and installed apps (reviews / subscriptions / bundles). Never treat as production data.

export const PDP_3_4_PRODUCT = {
  productThumb: "https://cdn.shopify.com/s/files/1/0821/1399/products/eye-repair.png?v=1776097214",
  category: "Bestseller · Eye Treatment",
  titleLines: ["Eye Repair Treatment"],
  routineStep: {
    label: "Step 3 · Hydration",
    icons: [
      { src: "https://www.riversol.com/cdn/shop/files/icon-sundim.png?v=1770857817&width=48", alt: "Day" },
      { src: "https://www.riversol.com/cdn/shop/files/icon-moon.png?v=1770857826&width=48", alt: "Night" },
    ],
  },
  rating: 4.9,
  reviewCount: 8761,
  price: { regular: "$59.00", member: "$53.10" },
  promo: "10% off with Riversol+ Membership",
  shortDescription: "Our best-selling creamy eye treatment helps reduce puffiness, dark circles & crow's feet. An advanced antioxidant and multi-peptide blend supports smoother, brighter skin in the eye area.",
  shipping: "Free shipping on orders over $69",
  returns: "30 day returns",
  perOrder: "",
  ctaLabel: "Add to cart",
  variants: [
    { id: "30ml", label: "30mL", detail: "In stock", price: "$59.00" },
  ],
  defaultVariant: "30ml",
  sizes: [
    { id: "30ml", label: "30 mL", sub: "", note: "" },
    { id: "60ml", label: "60 mL", sub: "", badge: "Save 15%", note: "" },
  ],
  defaultSize: "60ml",
  plans: [
    {
      id: "onetime",
      title: "One-time purchase",
      subtitle: "Ships once, no commitment",
      price: "$59.00",
      compareAt: null,
      unit: "CAD",
      badge: null,
      cta: "Add to cart",
    },
    {
      id: "membership",
      title: "Subscribe & save",
      subtitle: "10% off every order + free shipping & member perks",
      price: "$54.00",
      compareAt: "$59.00",
      unit: "CAD",
      badge: "Most popular",
      cta: "Join & add to cart",
      benefits: [
        "10% off every order, automatically",
        "Free shipping on every order",
        "Early access to new products & a birthday gift",
      ],
      gifts: [
        {
          image: "https://cdn.shopify.com/s/files/1/0821/1399/products/aa-serum.png?v=1776095507",
          label: "+ Free Anti-Aging Reparative Serum",
          meta: "with third order (worth $79)",
        },
      ],
      learnMore: { label: "How Riversol+ works", href: "https://www.riversol.com/pages/riversol_plus" },
      ribbon: "Most popular & best value",
    },
  ],
  defaultPlan: "membership",
  anniversaryOffer: { label: "Anniversary offer", text: "Get $38 off orders $75+ with code", code: "14YEARS" },
  gallery: [
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/products/eye-repair.png?v=1776097214",
      alt: "Eye Repair Treatment product",
      label: "Product",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164",
      alt: "Eye Repair Treatment cream texture",
      label: "Texture",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/files/1_e9d39bcd-f49e-40f2-85d6-1532041a33ad.jpg?v=1776097203",
      alt: "Eye Repair Treatment detail",
      label: "Detail",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/files/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209",
      alt: "Eye Repair Treatment key ingredients",
      label: "Actives",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/files/Option2_1.png?v=1776098169",
      alt: "Eye Repair Treatment benefits",
      label: "Benefits",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/products/EyeTreatment-KV6sm.png?v=1776097211",
      alt: "Eye Repair Treatment key visual",
      label: "Key visual",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0821/1399/files/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698",
      alt: "Eye Repair Treatment lifestyle",
      label: "In use",
    },
  ],
  routine: {
    eyebrow: "The more you add, the more you save",
    title: "Build your bundle",
    lifestyleImage: "https://cdn.shopify.com/s/files/1/0821/1399/files/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698",
    lifestyleAlt: "Complete your routine",
    products: [
      {
        name: "Anti-Aging Reparative Serum",
        reason: "Apply before eye cream to support the look of firmness across the whole face.",
        price: "$79.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/aa-serum.png?v=1776095507",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "30mL", price: "$49.00" },
          { label: "60mL", price: "$79.00", default: true },
        ],
      },
      {
        name: "Daily Moisturizing Cream",
        reason: "Lock in hydration and extend comfort after your eye treatment.",
        price: "$49.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/dmc_8215c1a3-320f-40e2-8cda-af33d45a4928.png?v=1776098827",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "50mL", price: "$49.00", default: true },
          { label: "100mL", price: "$79.00", soldOut: true },
        ],
      },
      {
        name: "Gentle Cleanser",
        reason: "Start the routine with a fragrance-free cleanser that respects sensitive skin around the eyes.",
        price: "$34.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "150mL", price: "$34.00", default: true },
          { label: "250mL", price: "$49.00" },
        ],
      },
      {
        name: "Facial Toner",
        reason: "Prep skin before serum and eye treatment for deeper absorption and even radiance.",
        price: "$29.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/EyeTreatment-KV6sm.png?v=1776097211",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "120mL", price: "$29.00", default: true },
        ],
      },
      {
        name: "Antioxidant Enhance Serum",
        reason: "Layer beneath moisturizer to reinforce the skin barrier and boost overall radiance day and night.",
        price: "$69.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "30mL", price: "$69.00", default: true, soldOut: true },
          { label: "60mL", price: "$109.00", soldOut: true },
        ],
      },
      {
        name: "Micro-Exfoliating Cleanser",
        reason: "Weekly refresh — gently sweeps away dull surface skin so eye actives absorb better.",
        price: "$39.00",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Option2_1.png?v=1776098169",
        // PLACEHOLDER sizes/stock — replace with Shopify variant data
        variants: [
          { label: "100mL", price: "$39.00", default: true },
          { label: "200mL", price: "$59.00" },
        ],
      },
    ],
  },
  alsoLove: {
    eyebrow: "Complete the ritual",
    title: "You may also love",
    products: [
      {
        name: "Anti-Aging Reparative Serum",
        tag: "Bestseller",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/aa-serum.png?v=1776095507",
        rating: 4.7,
        reviews: 2100,
        price: "$79.00",
        compareAt: null,
        variants: ["30 mL", "50 mL"],
        colors: [],
      },
      {
        name: "Daily Moisturizing Cream",
        tag: null,
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/dmc_8215c1a3-320f-40e2-8cda-af33d45a4928.png?v=1776098827",
        rating: 4.8,
        reviews: 1560,
        price: "$49.00",
        compareAt: null,
        variants: ["50 mL"],
        colors: [],
      },
      {
        name: "Gentle Cleanser",
        tag: "Editor's pick",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164",
        rating: 4.6,
        reviews: 890,
        price: "$34.00",
        compareAt: null,
        variants: ["130 mL"],
        colors: [],
      },
      {
        name: "Advanced Correcting Cream",
        tag: "New",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/EyeTreatment-KV6sm.png?v=1776097211",
        rating: 4.9,
        reviews: 420,
        price: "$99.00",
        compareAt: "$110.00",
        variants: ["30 mL", "50 mL"],
        colors: ["#f6e7d8", "#e6cbb2", "#c9a985"],
      },
      {
        name: "Antioxidant Enhance Serum",
        tag: null,
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209",
        rating: 4.7,
        reviews: 615,
        price: "$69.00",
        compareAt: null,
        variants: ["30 mL"],
        colors: [],
      },
      {
        name: "Facial Toner",
        tag: null,
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/1_e9d39bcd-f49e-40f2-85d6-1532041a33ad.jpg?v=1776097203",
        rating: 4.5,
        reviews: 480,
        price: "$29.00",
        compareAt: null,
        variants: ["130 mL"],
        colors: [],
      },
      {
        name: "Anti-Aging Trio",
        tag: "Bundle · Save 15%",
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698",
        rating: 4.9,
        reviews: 340,
        price: "$149.00",
        compareAt: "$176.00",
        variants: ["Full set"],
        colors: [],
      },
      {
        name: "Micro-Exfoliating Cleanser",
        tag: null,
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Option2_1.png?v=1776098169",
        rating: 4.6,
        reviews: 720,
        price: "$39.00",
        compareAt: null,
        variants: ["130 mL"],
        colors: [],
      },
    ],
  },
  reviews: {
    eyebrow: "Loved by real skin",
    title: "Customer stories",
    summary: {
      eyebrow: "",
      paragraph: "Across 8,761 verified reviews, shoppers reach for Eye Repair Treatment because it visibly softens puffiness and brightens dark circles without irritating sensitive skin. Most notice smoother, firmer eye contours within two weeks and appreciate how quickly the lightweight formula sinks in under makeup.",
      themes: [
        { label: "Reduces puffiness", count: 2814 },
        { label: "Brightens dark circles", count: 2416 },
        { label: "Gentle on sensitive skin", count: 2020 },
        { label: "Fast, visible results", count: 1638 },
        { label: "Non-greasy finish", count: 1270 },
      ],
      distribution: [
        { stars: 5, percent: 88 },
        { stars: 4, percent: 8 },
        { stars: 3, percent: 2 },
        { stars: 2, percent: 1 },
        { stars: 1, percent: 1 },
      ],
    },
    judgeme: {
      total: 8761,
      questionsTotal: 24,
      pages: 877,
      photos: [
        "https://review-images.judgeme.com/riversol/1784934493__5igjdg-then__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1784934495__apxosa-now__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1784166966__18aeqa-354071__original.jpg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1783352360__img_3362__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1782930473__img_7835__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1778948101__1000154558__original.jpg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1778821064__zjmn2q-_4440__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1770237280__img_4142__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1768037667__1000028697__original.jpg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1766865757__1000062458__original.jpg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1765633830__img_1575__original.jpeg?quality=80&width=160",
        "https://review-images.judgeme.com/riversol/1765633832__img_2181__original.jpeg?quality=80&width=160",
      ],
      items: [
        {
          rating: 5,
          author: "Linda",
          badge: "shop",
          date: "08/15/2026",
          title: null,
          body: "I just start to use it so far so good",
          source: "Review written in Shop App",
        },
        {
          rating: 5,
          author: "Anonymous",
          badge: "buyer",
          date: "08/14/2026",
          title: "Great product love it, face looks more brighter",
          body: "Great product love it, face looks more brighter and feels so soft.",
          reply: "Thank you so much for your wonderful review! We're thrilled to hear you love the product and see such great results. Enjoy your glowing skin!",
        },
        {
          rating: 5,
          author: "Janice C.",
          badge: "buyer",
          date: "08/12/2026",
          title: "Lovely to apply and noticeable difference",
          body: "Lovely to apply and noticeable difference.",
          reply: "Hi Janice, we're so glad to hear you love the Anti-Aging Trio! Thanks for sharing your experience.",
        },
        {
          rating: 5,
          author: "Camylle B.",
          badge: "buyer",
          date: "08/10/2026",
          title: "reparative spray",
          body: "I have used Riversol on my face for over a year and absolutely love it! Two days ago I used the reparative spray on my chest area. I have dry scaly skin on chest and arms. It is healing it already! My husband even noticed! Wow I love this stuff!",
          reply: "Hi Camylle, we're thrilled to hear how much you love our products! It's wonderful to know the reparative spray is helping your skin heal. Thank you for sharing your experience!",
        },
        {
          rating: 5,
          author: "Krista",
          badge: "shop",
          date: "08/07/2026",
          title: null,
          body: "Perfect for travel ans carry-on",
          source: "Review written in Shop App",
        },
        {
          rating: 5,
          author: "josephine a.",
          badge: "buyer",
          date: "08/05/2026",
          title: "GREAT PRODUCT",
          body: "I SEE GREAT IMPROVEMENT IN MY SKIN SINCE USING IT. IT IS ALMOST ONE YEAR AND I WILL KEEP BUYING IT. IT IS MY GO TO PRODUCT. PERFECT BY ITSELF OR UNDER MAKEUP.",
          reply: "Hi Josephine, we're thrilled to hear you're seeing such great results! Thank you for your continued trust in our Anti-Aging Trio with Peel. We're happy it's become your go-to. Looking forward to supporting your skincare journey!",
        },
        {
          rating: 5,
          author: "Nadine D.",
          badge: "buyer",
          date: "07/30/2026",
          title: "\"on it's way\"",
          body: "Just looking back at my purchases over the years and realize this one says \"on it's way\"",
          reply: "Hi Nadine, thanks for sharing! We're glad your order is on its way. We hope you enjoy the Anti-Aging To Go Set when it arrives!",
        },
      ],
    },
  },
};

export default PDP_3_4_PRODUCT;
